import React from 'react';

const asset = (name) => `${process.env.PUBLIC_URL}/design/${name}`;

export function WebpayLogo() {
  return <img className="webpay-logo" src={asset('webpay.svg')} alt="Webpay de Transbank" width="145" height="40" />;
}

export default function PaymentSecurity() {
  return (
    <div className="payment-security">
      <img className="payment-security__shield" src={asset('shield.svg')} alt="" width="40" height="44" />
      <div className="payment-security__copy">
        <strong>Tu pago está protegido</strong>
        <span>Transacción segura procesada por Transbank</span>
      </div>
      <div className="payment-security__brands" aria-label="Medios de pago: Webpay, Visa y Mastercard">
        <WebpayLogo />
        <span className="card-brand card-brand--visa">VISA</span>
        <span className="card-brand"><img src={asset('mastercard.svg')} alt="Mastercard" width="40" height="24" /></span>
      </div>
    </div>
  );
}